import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import DashboardLayout from '../layouts/DashboardLayout';
import { forceLogout } from '../store/slices/authSlice';
import { hasAnyEndpointAccess } from '../utils/rbac';
import AccessDenied403 from '../components/AccessDenied403';

const ProtectedRoute = ({ requiredPermissions = [] }) => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    // Check if token exists in localStorage
    const storedToken = localStorage.getItem('token');
    
    // If we think we're logged in but there's no token in localStorage
    // (which could happen if API interceptor cleared it), clear auth state
    if (isLoggedIn && !storedToken) {
      dispatch(forceLogout());
    }
  }, [dispatch, isLoggedIn, token]);

  // Check authentication status - both Redux state and localStorage must be in sync
  const isAuthenticated = isLoggedIn && localStorage.getItem('token');

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  if (requiredPermissions.length > 0 && !hasAnyEndpointAccess(user, requiredPermissions)) {
    return (
      <DashboardLayout>
        <AccessDenied403 />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
};

export default ProtectedRoute; 